var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartSolidRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F84F55",
    d: "M13.7 2.583A4.624 4.624 0 0 0 10 4.441a4.624 4.624 0 0 0-3.7-1.858c-2.559 0-4.634 2.083-4.634 4.658 0 .992.158 1.909.433 2.759 1.317 4.166 5.375 6.658 7.384 7.341.283.1.75.1 1.033 0 2.008-.683 6.067-3.175 7.383-7.341.275-.85.434-1.767.434-2.759 0-2.575-2.075-4.658-4.634-4.658Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSolidRed);
export default __webpack_public_path__ + "static/media/heart-solid-red.59de8d2e3e67ff4159c6da838ac56b81.svg";
export { ForwardRef as ReactComponent };